module.exports = __webpack_public_path__ + "static/media/becky.4a3f9195.jpg";